import { PURCHASE_REQUESTS_CRUD_ACTION_CREATORS } from '../actions/purchase_requests_actions';
import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';
import { getBackendUri } from '../utils/EnvConfigUtils';
import FetchUtils from './fetch_utils';
import { parseJSON } from './fetch_utils';
import { logoutSuccess } from '../actions/session_actions';
import PRPipeLineFilters from '../components/purchase_requests_index_page/PRPipelineFilters';
import { message } from 'antd';

const fetchUtils = new FetchUtils();
const BASE_URL = getBackendUri();

//export const purchaseRequestsRestCrudThunksForBuyer = new RestCrudThunks('purchase_requests', 'purchase_request', 'purchaseRequest', 'purchaseRequests', PURCHASE_REQUESTS_CRUD_ACTION_CREATORS, null, ROLE_TYPES.BUYER);
export const purchaseRequestsRestCrudThunksForSupplier = new RestCrudThunks(
	'purchase_requests',
	'purchase_request',
	'purchaseRequest',
	'purchaseRequests',
	PURCHASE_REQUESTS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'inventory/'
);

export const purchaseRequestsLiteRestCrudThunksForSupplier = new RestCrudThunks(
	'purchase_requests_lite',
	'purchase_request',
	'purchaseRequest',
	'purchaseRequests',
	PURCHASE_REQUESTS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'inventory/'
);

// Partial update for scalar fields on a Purchase Request via the generic PATCH endpoint.
// Only the fields present in `partialFields` are changed; omit a field to leave it
// unchanged, or send it as null to clear it. Returns the fully hydrated, updated PR.
export const patchPurchaseRequest = (userType) => (id, partialFields) => {
	const apiUrl = `/api/v1/${userType}/inventory/purchase_requests/${id}`;
	return (dispatch) => {
		dispatch(PURCHASE_REQUESTS_CRUD_ACTION_CREATORS.updateStart({ id, ...partialFields }));
		return new Promise((resolve, reject) => {
			fetchUtils
				.patch(BASE_URL + apiUrl, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					data: partialFields,
				})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const response = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (!ok || response.status === 'error') {
						dispatch(PURCHASE_REQUESTS_CRUD_ACTION_CREATORS.updateError(response.message, { id }));
						reject(response.message);
					} else {
						dispatch(PURCHASE_REQUESTS_CRUD_ACTION_CREATORS.updateSuccess(response.data));
						resolve(response.data);
					}
				})
				.catch((error) => {
					dispatch(PURCHASE_REQUESTS_CRUD_ACTION_CREATORS.updateError(error.message, { id }));
					reject(error.message);
				});
		});
	};
};

export const purchaseRequestStatusChangeForSupplier = (
	id,
	status,
	equipmentReceiptValues = undefined
) => {
	const apiUrl = `/api/v1/supplier/inventory/purchase_requests`;
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			fetchUtils
				.patch(
					BASE_URL + apiUrl + `/${id}/${status}`,
					Object.assign({
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: { equipmentReceiptValues },
					})
				)
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (d.status === 'error') {
						dispatch(PURCHASE_REQUESTS_CRUD_ACTION_CREATORS.updateError(d.message, id));
						reject(d.message);
					} else {
						dispatch(PURCHASE_REQUESTS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(PURCHASE_REQUESTS_CRUD_ACTION_CREATORS.updateError(d.message, id));
					reject(d.message);
				});
		});
	};
};

export const fetchAssociatedPRsOfPurchaseOrderForSupplier = (poId) => {
	// if pagination present, transform into limit/offset format and add to query params

	const apiUrl = `/api/v1/supplier/inventory/purchase_requests/from_po_id/${poId}`;

	return new Promise((resolve, reject) => {
		fetchUtils
			.get(
				BASE_URL + apiUrl,
				Object.assign({
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
				})
			)
			.then(parseJSON)
			.then(({ json, status, ok }) => {
				const d = json;
				if (d.status === 'error') {
					reject(d.message);
				} else {
					resolve(d.data);
				}
			})
			.catch((d) => {
				reject(d.message);
			});
	});
};

export const refreshPRCountsForSupplier = (filters) => (dispatch) => {
	const apiUrl = `/api/v1/supplier/inventory/purchase_requests/count_by_status`;

	const data = {
		...(filters || {}),
		statuses: PRPipeLineFilters.map((_) => _.name).join(','),
		status: undefined,
	};
	fetchUtils
		.get(
			BASE_URL + apiUrl,
			Object.assign(
				{
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
				},
				data
			)
		)
		.then(parseJSON)
		.then(({ json, status, ok }) => {
			const d = json;
			if (d.status === 'error') {
				message.error(d.message);
			} else {
				if (d.data && d.data.length > 0) {
					d.data.map((category) =>
						dispatch(
							PURCHASE_REQUESTS_CRUD_ACTION_CREATORS.countBySuccess(
								category.count,
								category.categoryName
							)
						)
					);
				}
			}
		})
		.catch((d) => {
			message.error(d.message);
		});
};

export const syncPurchaseRequestApprovalHierarchy = (userType) => (entity) => {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(PURCHASE_REQUESTS_CRUD_ACTION_CREATORS.updateStart(entity));

			fetchUtils
				.patch(
					BASE_URL +
						`/api/v1/${userType}/inventory/purchase_requests/approval_hierarchy_update/${entity.id}`,
					{}
				)
				.then((response: any) => response.json())
				.then((d) => {
					if (d.status === 'error') {
						dispatch(PURCHASE_REQUESTS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					} else {
						dispatch(PURCHASE_REQUESTS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(PURCHASE_REQUESTS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
					reject(d.message);
				});
		});
	};
};

export const syncPurchaseRequestApprovalHierarchyForSupplier =
	syncPurchaseRequestApprovalHierarchy('supplier');

export const bulkApprovePurchaseRequestForSupplier = (ids) => {
	const apiUrl = `/api/v1/supplier/inventory/purchase_requests/bulk_approve/${ids.join(',')}`;
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			fetchUtils
				.put(
					BASE_URL + apiUrl,
					Object.assign({
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					})
				)
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (d.status === 'error') {
						dispatch(PURCHASE_REQUESTS_CRUD_ACTION_CREATORS.updateError(d.message, {}));
						reject(d.message);
					} else {
						dispatch(PURCHASE_REQUESTS_CRUD_ACTION_CREATORS.updateBulkSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(PURCHASE_REQUESTS_CRUD_ACTION_CREATORS.updateError(d.message, {}));
					reject(d.message);
				});
		});
	};
};
